import * as React from "react";
const HeartIcon = (props: any) => (
  <svg
    width="current"
    height="current"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1319_27137"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <rect width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1319_27137)">
      <path
        d="M11.9904 19.7096C11.7763 19.7096 11.5612 19.6711 11.3452 19.5942C11.1291 19.5173 10.9391 19.3968 10.775 19.2327L9.33848 17.9269C7.56539 16.3102 5.98238 14.7221 4.58943 13.1625C3.19648 11.6029 2.5 9.93203 2.5 8.15C2.5 6.73078 2.97852 5.54265 3.93558 4.5856C4.89263 3.62855 6.08076 3.15002 7.49998 3.15002C8.30638 3.15002 9.10285 3.33593 9.8894 3.70773C10.6759 4.07953 11.3795 4.68337 12 5.51927C12.6205 4.68337 13.324 4.07953 14.1105 3.70773C14.8971 3.33593 15.6936 3.15002 16.5 3.15002C17.9192 3.15002 19.1073 3.62855 20.0644 4.5856C21.0214 5.54265 21.5 6.73078 21.5 8.15C21.5 9.95127 20.7916 11.6407 19.375 13.2183C17.9583 14.7958 16.3788 16.3705 14.6365 17.9423L13.2154 19.2327C13.0513 19.3968 12.8596 19.5173 12.6404 19.5942C12.4211 19.6711 12.2045 19.7096 11.9904 19.7096ZM11.2808 7.03848C10.7397 6.21411 10.1702 5.60994 9.5721 5.22598C8.97402 4.84199 8.28331 4.65 7.49998 4.65C6.49998 4.65 5.66664 4.98333 4.99998 5.65C4.33331 6.31667 3.99998 7.15 3.99998 8.15C3.99998 8.95257 4.25863 9.79167 4.77593 10.6673C5.29323 11.5429 5.94258 12.4134 6.72398 13.2788C7.50539 14.1442 8.35187 14.9897 9.2634 15.8154C10.1749 16.641 11.0198 17.4083 11.798 18.1173C11.8557 18.1686 11.923 18.1942 12 18.1942C12.0769 18.1942 12.1442 18.1686 12.2019 18.1173C12.9801 17.4083 13.825 16.641 14.7366 15.8154C15.6481 14.9897 16.4946 14.1442 17.276 13.2788C18.0574 12.4134 18.7067 11.5429 19.224 10.6673C19.7413 9.79167 20 8.95257 20 8.15C20 7.15 19.6666 6.31667 19 5.65C18.3333 4.98333 17.5 4.65 16.5 4.65C15.7166 4.65 15.0259 4.84199 14.4279 5.22598C13.8298 5.60994 13.2602 6.21411 12.7192 7.03848C12.6346 7.16668 12.5282 7.26283 12.4 7.32695C12.2718 7.39105 12.1384 7.4231 12 7.4231C11.8615 7.4231 11.7282 7.39105 11.6 7.32695C11.4718 7.26283 11.3654 7.16668 11.2808 7.03848Z"
        fill="current"
      />
    </g>
  </svg>
);
export default HeartIcon;
